/**
 * @file Overlay
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Polyfill:element-prototype-classlist 'Element.classList'
 */

export default {

  /**
   * Create Overlay
   *
   * @returns {boolean}
   *   False if the overlay already exists, True otherwise.
   */
  create: function create() {
    if ( !this.overlay ) {
      this.overlay = document.createElement( 'div' );
      this.overlay.id = 'ac-menu-overlay';
      this.overlay.classList.add( 'ac-menu-overlay' );
      return true;
    }
    // Overlay exist
    return false;
  },


  /**
   * Destroy Overlay
   */
  destroy: function destroy() {
    if ( this.overlay ) {
      this.overlay.parentNode.removeChild( this.overlay );
      this.overlay = null;
    }
  },


  /**
   * Show Overlay
   */
  show: function show() {
    this.overlay.clientWidth;
    this.overlay.classList.add( 'js-is--displayed' );
    this.overlay.clientWidth;
    this.overlay.classList.add( 'js-is--visible' );
  },


  /**
   * Hide Overlay
   */
  hide: function hide() {
    this.overlay.clientWidth;
    this.overlay.classList.remove( 'js-is--visible' );
    this.overlay.clientWidth;
    this.overlay.classList.remove( 'js-is--displayed' );
    this.destroy();
  },

  /**
   * Function to execute when overlay is clicked
   *
   * @callback
   * @param {Function} callback
   *   Callback function.
   * @returns {boolean}
   *   false if the overlay exists.
   */
  onOverlayClick: function onOverlayClick( callback = () => {}) {
    if ( !this.overlay ) {
      // Overlay exist
      return false;
    }
    this.overlay.addEventListener( 'click', callback );
  },

};
